module.exports = __webpack_public_path__ + "static/5-0aa23869c74154eb5ccedcaf03c1e651.jpeg";